import React from 'react';
import '../styles/app/forms.css';

class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    if (typeof window !== 'undefined' && window.console) {
      console.error('ErrorBoundary caught:', error, info?.componentStack);
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  handleHome = () => {
    window.location.href = '/';
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="pnp-sys-error" role="alert">
        <span className="pnp-claw" aria-hidden="true" />
        <div className="pnp-sys-error-icon" aria-hidden="true">!</div>
        <h1 className="pnp-sys-error-title">Something went <span className="pnp-punch">wrong</span></h1>
        <p>
          We hit an unexpected error. Reloading usually fixes it. If it keeps happening,
          send a note to <a href="mailto:kyle@picknpray.com">kyle@picknpray.com</a>.
        </p>
        <div className="pnp-sys-error-actions">
          <button onClick={this.handleReload} className="btn btn-primary btn-lg">
            Reload
          </button>
          <button onClick={this.handleHome} className="btn btn-secondary btn-lg">
            Go home
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
